const T_PREFIX = "search";

export const searchTrns = {
  viewAll: `${T_PREFIX}.buttons.view-all-btn`,
  search: `${T_PREFIX}.buttons.search-btn`,

  minInvestment: `${T_PREFIX}.input.min-investment`,
  listPrice: `${T_PREFIX}.input.list-price`,
  industry: `${T_PREFIX}.input.industry`,
};

